import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_openBlock(), _createBlock(_component_GoogleMap, {
    "api-key": "AIzaSyA7lCGzuRzH5NJ6G9il4mHj2v40Xt7dE7c",
    style: {"height":"100%"},
    ref: "mapRef",
    center: _ctx.mapCenter,
    zoom: 9
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeLocatorMarkers, (s) => {
        return (_openBlock(), _createBlock(_component_Marker, {
          key: 'marker-' + s.id,
          options: { ..._ctx.getMarker(s) },
          onClick: () => _ctx.onClickMarker(s)
        }, null, 8, ["options", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["center"]))
}